//
// locales/glitch/ro.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/flavours/glitch/locales/ro';
import localeData from 'react-intl/locale-data/ro.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
